import { Link } from "react-router-dom";
import { FileText, LogOut, Crown } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";
import { formatDate } from "../lib/api";

export const Logo = () => (
  <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
    <span className="h-8 w-8 rounded-lg bg-emerald-500 text-black flex items-center justify-center">
      <FileText className="h-4 w-4" strokeWidth={2.5} />
    </span>
    <span className="font-display font-extrabold text-lg tracking-tight">Rezume Ink</span>
  </Link>
);

const PlanBadge = ({ user }) =>
  user.has_access ? (
    <span data-testid="nav-plan-active" className="hidden sm:flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-emerald-400 border border-emerald-500/30 bg-emerald-500/10 rounded-full px-3 py-1">
      <Crown className="h-3 w-3" /> Pro · until {formatDate(user.access_until)}
    </span>
  ) : (
    <Link to="/pricing" data-testid="nav-upgrade-link" className="hidden sm:inline text-xs font-mono uppercase tracking-widest text-amber-400 hover:text-amber-300 transition-colors">
      Free · Upgrade
    </Link>
  );

export const Navbar = () => {
  const { user, login, logout } = useAuth();
  return (
    <header className="sticky top-0 z-40 border-b border-white/5 bg-[#090A0F]/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="flex items-center gap-3 sm:gap-5">
          <Link to="/pricing" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="nav-pricing-link">Pricing</Link>
          {user ? (
            <>
              <PlanBadge user={user} />
              <Link to="/dashboard" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="nav-dashboard-link">My resumes</Link>
              {user.picture && <img src={user.picture} alt="" className="h-8 w-8 rounded-full border border-white/10" data-testid="nav-avatar" />}
              <button onClick={logout} className="text-slate-400 hover:text-white transition-colors" data-testid="nav-logout-btn" aria-label="Log out">
                <LogOut className="h-4 w-4" />
              </button>
            </>
          ) : (
            <Button onClick={() => login()} data-testid="nav-login-btn" className="rounded-full bg-white text-black hover:bg-emerald-400 hover:text-black">
              Sign in
            </Button>
          )}
        </nav>
      </div>
    </header>
  );
};
